const {Component} = require("react");
const PropTypes = require("prop-types");
const renderer = require("app/services/renderer");
const Link = require("app/components/mixins/Link");
const hammer = require("app/util/hammer");

class BurgerItem extends Component {

  static get propTypes() {
    return {
      navSelector: PropTypes.string
    }
  }

  static get defaultProps() {
    return {
      navSelector: ".header .navigation-wrapper"
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      toggled: false,
      isOpen: false,
      canClick: true,
    };
  }

  componentDidMount() {
    const nav = document.querySelector(this.props.navSelector);
    this.setState({isOpen: true});

    const handleClickAway = e => {
      if (nav.contains(e.target) || this.burgerElement.element.contains(e.target)) {
        return;
      }

      this.toggleMobileSearchText(false);
      this.toggleBodyScroll(false);
      this.toggleNavigation(false);
      this.setState({toggled: false});

    };

    if (nav) {
      // Click outside
      document.body.addEventListener("click", e => handleClickAway(e));
      hammer(document.body).on("tap", e => handleClickAway(e));

    }
  }

  get className() {
    let classList = ["burger"];

    if (this.state.toggled) {
      classList.push("animated");
    }

    return classList.join(" ");
  }

  toggleBodyScroll(state) {
    let body = document.body;
    let classList = body.className.split(" ");
    let index = classList.indexOf("no-scroll");

    if (state) {
      if (index === -1) {
        classList.push("no-scroll");
      }
    } else {
      if (index > -1) {
        classList.splice(index, 1);
      }
    }

    body.className = classList.join(" ");
  }

  toggleNavigation(state) {
    let nav = document.querySelector(this.props.navSelector);

    if (nav) {
      let classList = nav.className.split(" ");
      let index = classList.indexOf("active");

      if (state) {
        if (index === -1) {
          classList.push("active");

          const mobileSearch = renderer.element("mobile-search");

          if (mobileSearch) {
            mobileSearch.focus();
          }
        }
      } else {
        if (index > -1) {
          classList.splice(index, 1);
        }
      }

      nav.className = classList.join(" ");
    }
  }

  toggleMobileSearchText(state) {
    let element = renderer.element("mobile-search");

    if ((state === false) && element) {
      //element.empty();
    }
  }

  toggleActiveTransition(state) {
    let nav = document.querySelector(this.props.navSelector);
    let classList = nav.className.split(" ");
    classList.push("active-transition");
    nav.className = classList.join(" ");
    let index = classList.indexOf("active-transition");

    setTimeout(() => {
      this.setState({
        canClick: true
      });
      classList.splice(index, 1);
      nav.className = classList.join(" ");

    }, 300)
  }

  _onClick = () => {
    if (this.state.canClick) {
      this.setState({
        canClick: false
      });

      let toggled = !this.state.toggled;

      this.toggleMobileSearchText(toggled);
      this.toggleBodyScroll(toggled);
      this.toggleNavigation(toggled);
      this.toggleActiveTransition(this.state.isOpen)
      this.setState({toggled});
      this.setState(prevState => ({
        isOpen: !prevState.isOpen
      }));
    }
  };

  render() {
    return (
      <Link ref={el => this.burgerElement = el} className={this.className} href="#" onClick={this._onClick}>
        <div className="line-1"></div>
        <div className="line-2"></div>
        <div className="line-3"></div>
      </Link>
    );
  }

}

module.exports = BurgerItem;
